import {OpaqueToken} from '@angular/core';

export const ON_WEB_WORKER = new OpaqueToken('WebWorker.onWebWorker');

interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
